import styled from 'styled-components';
interface IRadioButtonComponentProps {
  numberOfTabs: number;
}
export const RadioButtonComponent = styled.div<IRadioButtonComponentProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  .ant-radio-group {
    width: 100%;
  }
  .ant-radio-button-wrapper {
    border: 1px solid #dae6fd;
    height: fit-content;
    img {
      width: 18px;
      height: 18px;
      filter: invert(35%) sepia(3%) saturate(1221%) hue-rotate(157deg)
        brightness(98%) contrast(96%);
    }
    width: calc(100% / ${(props) => props.numberOfTabs});
    line-height: 20px;
    padding: 10px 0px;
    min-width: max-content;
  }
  .ant-radio-button-wrapper:hover {
    border-color: transparent;
    background-color: #f6f7f7;
  }
  .ant-radio-button-wrapper:first-child {
    border-radius: 8px 0px 0px 8px;
    border-right-width: 0px;
    border-color: #dae6fd;
  }
  .ant-radio-button-wrapper:last-child {
    border-radius: 0px 8px 8px 0px;
    border-left-width: 0px;
    border-color: #dae6fd;
  }
  .ant-radio-button-wrapper-checked {
    background-color: #dae6fd;
    img {
      filter: none;
    }
    &:hover {
      background-color: #dae6fd;
    }
  }
  /* label */
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    color: #1a1a1a;
    font-weight: 700;
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover::before {
    background-color: transparent;
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):focus-within {
    box-shadow: 0 0 0 0px;
  }
  .ant-radio-button-wrapper:not(.ant-radio-button-wrapper-checked) {
    color: #525b60;
  }
  .ant-radio-button-wrapper.ant-radio-button-wrapper-rtl.ant-radio-button-wrapper:first-child {
    border-radius: 0px 8px 8px 0px;
    border-left-width: 0px;
    border-color: #dae6fd;
  }
  .ant-radio-button-wrapper.ant-radio-button-wrapper-rtl.ant-radio-button-wrapper:last-child {
    border-radius: 8px 0px 0px 8px;
    border-right-width: 0px;
    border-left-width: 1px;
    border-color: #dae6fd;
  }
`;
export const ButtonLabel = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  gap: 12px;
  font-size: 16px;
  justify-content: center;
`;
